export const PORTAL_BRAND_STATUS = {
  PENDING: 'pending',
  LEGACY: 'legacy',
  NEUTRAL: 'neutral',
  FIRM: 'firm',
}

export const LEGACY_PORTAL_BRAND = { status: PORTAL_BRAND_STATUS.LEGACY }
